// Mock discovery results for the unified Evidence Discovery modal

export interface EuropePmcResult {
  id: string
  title: string
  authors: string
  journal: string
  year: number
  doi: string
  snippet: string
  isOpenAccess: true
}

export interface PubMedResult {
  id: string
  title: string
  authors: string
  journal: string
  year: number
  doi: string
  abstract: string
}

export interface SciteResult {
  id: string
  title: string
  authors: string
  journal: string
  year: number
  doi: string
  citationStatement: string
}

export type DiscoveryResult = EuropePmcResult | PubMedResult | SciteResult

export const mockEuropePmcResults: EuropePmcResult[] = []

export const mockPubMedResults: PubMedResult[] = []

export const mockSciteResults: SciteResult[] = []
